<template>
  <main-layout>

    <div slot="left-side">
      <menubar screenIdParam="M-06-80"></menubar>
    </div>

    <!--  メインページ 開始  -->
    <el-row slot="header">
      <head-title>
        <label slot="title">
          {{ $t('label.system.menuChange.menuNameChange') }}
        </label>
        <lvory-but
          slot="create"
          class="header-clear-btn"
          @click="backPage">
          {{ $t("button.common.cancel") }}
        </lvory-but>
        <narrow-down
          @click="updateOwnerMenuName"
          slot="button"
        >
          {{ $t('button.system.menuChange.applySettings') }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <el-form
        ref="ruleForm"
        class="c-auth-form"
        label-width="188px"
        label-position="left"
        hide-required-asterisk>

        <div class="usage-terminal-name">
          {{ $t('label.system.menuChange.userApp') }}
        </div>

        <!--  利用者アプリ检索結果展示 开始  -->
        <div ref="searchResultTable" id="menu-change-result" class="menu-table">
          <menu-search-result-beautify
            :isShow="isUsageSpShow"
            v-if="this.isUsageSpShow"
            :result="usageSpSearchResult"
            @changeResult="changeSpSearchResult($event)"
          />
        </div>
        <!--  利用者アプリ检索結果展示 结束  -->

        <div class="usage-terminal-name usage-web">
          {{ $t('label.system.menuChange.userWeb') }}
        </div>

        <!--  利用者アプリ检索結果展示 开始  -->
        <div ref="searchResultTable" id="menu-change-result" class="menu-table">
          <menu-search-result-beautify
            :isShow="isUsageWebShow"
            v-if="this.isUsageWebShow"
            :result="usageWebSearchResult"
            @changeResult="changeWebSearchResult($event)"
          />
        </div>
        <!--  利用者アプリ检索結果展示 结束  -->

      </el-form>

      <dialog-confirm
        class="menu-confirm-popup"
        :visible.sync="isDialogConfirmComplete"
        :clickFlag="false"
        :cancelFlag="true"
        :titleMsg="dialogComplete.title"
        :contentMsg="dialogComplete.content"
        @on-confirm="doneUpdateOwnerMenuName"/>

      <loading-dialog :dialogVisible="showLoading" />
    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import HeadTitle from "@/components/common/head/headDetail"
import MainLayout from "@/layout/NewDesignLayout"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import SystemManageApi from "@/api/SystemManageApi"
import DialogConfirm from "@/components/common/el-dialog-prompt/confirm"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import MenuSearchResultBeautify from "@/components/system/MenuSearchResultBeautify"

export default {
  name: "MenuChangeEdit",
  components: {
    Menubar: Menubar,
    LvoryBut: LvoryBut,
    HeadTitle: HeadTitle,
    MainLayout: MainLayout,
    narrowDown: narrowDown,
    LoadingDialog: LoadingDialog,
    DialogConfirm: DialogConfirm,
    MenuSearchResultBeautify: MenuSearchResultBeautify
  },
  data() {
    return {
      isUsageSpShow: false,
      isUsageWebShow: false,
      showLoading: false,
      orgId: null,
      usageSpSearchResult: [],
      usageWebSearchResult: [],
      dialogComplete: {
        title: this.$t('message.system.menuChange.createConfirmTitle'),
        content: this.$t('message.system.menuChange.createConfirm')
      },
      isDialogConfirmComplete: false
    }
  },
  created() {
    this.$authCheck("010213")
    this.orgId = this.$route.params.ownerId
    this.ownerDetail = JSON.parse(this.$route.params.ownerDetail)

    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.menuChange",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  mounted() {
    this.getMenuChangeInfoApi()
  },
  methods: {
    changeSpSearchResult(data) {
      this.usageSpSearchResult = data
    },
    changeWebSearchResult(data) {
      this.usageWebSearchResult = data
    },
    getMenuChangeInfoApi () {
      this.usageWebSearchResult = []
      this.usageSpSearchResult = []
      this.showLoading = true
      SystemManageApi.getMenuChangeInfo(this.orgId)
        .then(({data}) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return
          }

          if (data.body != null && data.body != undefined && data.body != "") {

            const bodyMenuList = data.body.menuList

            if (bodyMenuList != null && bodyMenuList.length > 0) {
              for (let i = 0; i < bodyMenuList.length; i++) {
                // 利用Web
                if (bodyMenuList[i].usageTerminal == "02") {
                  this.usageWebSearchResult.push({
                    displayArea: bodyMenuList[i].displayArea,
                    menuType: bodyMenuList[i].menuType,
                    menuCode: bodyMenuList[i].menuCode,
                    systemMenuName: bodyMenuList[i].systemMenuName,
                    ownerMenuNameSettingFlag: bodyMenuList[i].ownerMenuNameSettingFlag,
                    ownerMenuName: bodyMenuList[i].ownerMenuName,
                    menuDigit: bodyMenuList[i].menuDigit != undefined && bodyMenuList[i].menuDigit != null ? bodyMenuList[i].menuDigit : 10
                  });
                  this.isUsageWebShow = true
                }

                // SP
                if (bodyMenuList[i].usageTerminal == "03") {
                  this.usageSpSearchResult.push({
                    displayArea: bodyMenuList[i].displayArea,
                    menuType: bodyMenuList[i].menuType,
                    menuCode: bodyMenuList[i].menuCode,
                    systemMenuName: bodyMenuList[i].systemMenuName,
                    ownerMenuNameSettingFlag: bodyMenuList[i].ownerMenuNameSettingFlag,
                    ownerMenuName: bodyMenuList[i].ownerMenuName,
                    menuDigit: bodyMenuList[i].menuDigit != undefined && bodyMenuList[i].menuDigit != null ? bodyMenuList[i].menuDigit : 10
                  });
                  this.isUsageSpShow = true
                }
              }
            }
          }
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },

    updateOwnerMenuName () {
      this.isDialogConfirmComplete = true
    },

    doneUpdateOwnerMenuName () {
      const menuList = []

      for (let i = 0; i < this.usageWebSearchResult.length; i++) {
         if (this.usageWebSearchResult[i].ownerMenuNameSettingFlag) {
          menuList.push({
            usageTerminal: "02",
            menuCode: this.usageWebSearchResult[i].menuCode,
            menuName: this.usageWebSearchResult[i].ownerMenuName
          });
        } else {
          menuList.push({
            usageTerminal: "02",
            menuCode: this.usageWebSearchResult[i].menuCode,
            menuName: null
          });
        }
      }

      for (let j = 0; j < this.usageSpSearchResult.length; j++) {
         if (this.usageSpSearchResult[j].ownerMenuNameSettingFlag) {
          menuList.push({
            usageTerminal: "03",
            menuCode: this.usageSpSearchResult[j].menuCode,
            menuName: this.usageSpSearchResult[j].ownerMenuName
          });
        } else {
          menuList.push({
            usageTerminal: "03",
            menuCode: this.usageSpSearchResult[j].menuCode,
            menuName: null
          });
        }
      }

      let request = {
        menuList: menuList
      }

      this.showLoading = true
      SystemManageApi.updateMenuChangeInfo(this.orgId, request)
        .then(({data}) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return
          }

          if (data.statusCode == "Success") {
            this.$messageIotSuccess(this.$t("message.common.save"))
          }
          this.getMenuChangeInfoApi()
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },

    backPage () {
      this.$router.push({
        name: "system-owner-setting-edit",
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.usage-terminal-name {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  line-height: 30px;
  color: #525250;
}

.share-display {
  color: #525250;
}

.menu-table {
  margin-top: 4px;
}

.usage-web {
  margin-top: 60px
}

.menu-confirm-popup::v-deep .confirm-btn {
  .my-button,
  .btn-default:hover {
    color: #FFFFFF !important;
    background-color: #329CA6;
    box-shadow: -4px -4px 5px #FFFFFF, 3px 3px 6px #B8B8AD !important;
  }
}
</style>
